import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Award } from "lucide-react";

export default function About() {
  const { settings } = useSettings();
  if (!settings) return <p className="text-muted-foreground">Loading...</p>;

  return (
    <div className="max-w-4xl mx-auto">
      <div className="border-b-2 border-primary pb-4 mb-8">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground">About</div>
        <h1 className="font-kannada-heading text-4xl sm:text-5xl mt-1">
          ನಮ್ಮ ಬಗ್ಗೆ <span className="text-primary">.</span>
        </h1>
      </div>

      <p className="font-kannada-body text-lg leading-[1.9] mb-10 dropcap">
        {settings.about_text}
      </p>

      {settings.mission && (
        <div className="border-l-4 border-secondary bg-muted/50 p-6 mb-10">
          <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground flex items-center gap-2">
            <Award className="w-3 h-3" /> Mission
          </div>
          <p className="font-kannada-heading text-2xl mt-2">{settings.mission}</p>
        </div>
      )}

      {/* Editor card */}
      <section className="border border-border bg-card p-6 rounded-sm" data-testid="editor-card">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground mb-4">
          Editorial Leadership
        </div>
        <div className="flex flex-col sm:flex-row gap-6 items-start">
          {settings.editor_photo_url && (
            <img
              src={settings.editor_photo_url}
              alt={settings.editor_name}
              className="w-32 h-32 object-cover rounded-sm border border-border"
            />
          )}
          <div>
            <div className="font-kannada-heading text-2xl">{settings.editor_name}</div>
            <div className="text-sm text-primary font-bold uppercase tracking-widest mt-1">
              {settings.editor_designation}
            </div>
            {settings.editor_bio && (
              <p className="font-kannada-body text-base mt-3 leading-relaxed">
                {settings.editor_bio}
              </p>
            )}
          </div>
        </div>
      </section>

      <div className="mt-10 text-center flex flex-wrap gap-3 justify-center">
        <Link
          to="/team"
          className="inline-flex items-center gap-2 px-6 py-3 border border-border font-semibold hover:bg-foreground hover:text-background transition-colors rounded-sm"
          data-testid="about-team-cta"
        >
          ನಮ್ಮ ತಂಡ ನೋಡಿ
        </Link>
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground font-semibold hover:opacity-90 transition-opacity rounded-sm"
          data-testid="about-contact-cta"
        >
          <Mail className="w-4 h-4" /> ಸಂಪರ್ಕಿಸಿ
        </Link>
      </div>
    </div>
  );
}
